if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // Inicia a página sem nenhuma opção de variante marcada
const productFormId = this.form.getAttribute('id');

document
  .querySelectorAll(
    `variant-radios input[type="radio"][form="${productFormId}"]`
  )
  .forEach((radio) => {
    radio.checked = false;
  });
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
onSubmitHandler(evt) {
  evt.preventDefault();

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  /*
   * Validação das opções do produto.
   * Impede adicionar ao carrinho sem selecionar todas as variantes.
   */
  const productFormId = this.form.getAttribute('id');

  const variantRadios = document.querySelectorAll(
  `variant-radios input[type="radio"][form="${productFormId}"]`
);

  if (variantRadios.length > 0) {
    const optionNames = [
      ...new Set(
        Array.from(variantRadios).map((radio) => radio.getAttribute('name'))
      ),
    ];

const missingOptions = optionNames.filter((optionName) => {
  return !document.querySelector(
    `variant-radios input[type="radio"][form="${productFormId}"][name="${CSS.escape(optionName)}"]:checked`
  );
});
    if (missingOptions.length > 0) {
      let message = 'Por favor, selecione as opções do produto antes de continuar.';

      if (missingOptions.length === 1) {
        const optionName = missingOptions[0].toLowerCase();

        if (
          optionName.includes('numeração') ||
          optionName.includes('numeracao') ||
          optionName.includes('tamanho')
        ) {
          message = 'Por favor, selecione a numeração antes de continuar.';
        } else if (optionName.includes('altura')) {
          message = 'Por favor, selecione a altura antes de continuar.';
        }
      }

      this.handleErrorMessage(message);

      const firstMissingOption = document.querySelector(
  `variant-radios input[type="radio"][form="${productFormId}"][name="${CSS.escape(missingOptions[0])}"]`
);

      if (firstMissingOption) {
        firstMissingOption
          .closest('.product-form__input')
          ?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
      }

      return;
    }

    /*
     * Também impede que as variantes auxiliares
     * "Numeração" e "Altura" sejam aceitas como escolhas.
     */
    const invalidValues = ['numeração', 'numeracao', 'altura'];

    const invalidSelection = Array.from(variantRadios).find((radio) => {
      return (
        radio.checked &&
        invalidValues.includes(radio.value.trim().toLowerCase())
      );
    });

    if (invalidSelection) {
      const invalidValue = invalidSelection.value
        .trim()
        .toLowerCase();

      const message =
        invalidValue === 'altura'
          ? 'Por favor, selecione uma altura válida antes de continuar.'
          : 'Por favor, selecione uma numeração válida antes de continuar.';

      this.handleErrorMessage(message);

      invalidSelection
        .closest('.product-form__input')
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

      return;
    }
  }

  this.handleErrorMessage();
      

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

          this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }
        
                fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
